<div class="wrapper">
  <div class="content">
    <div class="triangle"></div>
    <p><ng-content></ng-content></p>
    <div class="border"></div>
  </div>
</div>
